export default "__VITE_ASSET__b2e424cb__"